/* import __COLOCATED_TEMPLATE__ from './verification-banner.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
var CDPEvent = /*#__PURE__*/function (CDPEvent) {
  CDPEvent["BannerViewed"] = "unit_message_unit_viewed";
  return CDPEvent;
}(CDPEvent || {});
var RiskMessageType = /*#__PURE__*/function (RiskMessageType) {
  RiskMessageType["IdentityVerification"] = "IdentityVerification";
  RiskMessageType["SSP"] = "SSP";
  RiskMessageType["SSPRecased"] = "SSPRecased";
  return RiskMessageType;
}(RiskMessageType || {});
let VerificationBanner = (_class = class VerificationBanner extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "verificationBanners", _descriptor, this);
    if (this.showVeriffBanner) {
      this.trackIdentityVerification(CDPEvent.BannerViewed);
    } else if (this.showPendingSSPBanner) {
      this.trackSSP(CDPEvent.BannerViewed);
    } else if (this.showRecasedSSPBanner) {
      this.trackRecasedSSP(CDPEvent.BannerViewed);
    }
  }
  get showVeriffBanner() {
    return this.verificationBanners.showVeriffBanner(this.args.riskProfileUnits);
  }
  get showPendingSSPBanner() {
    return this.verificationBanners.showPendingSSPBanner(this.args.riskProfileUnits);
  }
  get showRecasedSSPBanner() {
    return this.verificationBanners.showRecasedSSPBanner(this.args.riskProfileUnits);
  }
  trackVerificationEvent(event, riskMessageType, riskProfileUnit) {
    this.verificationBanners.trackVerificationEvent(event, riskMessageType, riskProfileUnit);
  }
  trackSSP(event) {
    this.verificationBanners.trackSSP(event, this.args.riskProfileUnits);
  }
  trackRecasedSSP(event) {
    this.verificationBanners.trackRecasedSSP(event, this.args.riskProfileUnits);
  }
  trackIdentityVerification(event) {
    this.verificationBanners.trackIdentityVerification(event, this.args.riskProfileUnits);
  }
  openPendingSSP() {
    this.verificationBanners.openPendingSSP(this.args.goToBusinessInformation, this.args.riskProfileUnits);
  }
  openRecasedSSP() {
    this.verificationBanners.openRecasedSSP(this.args.goToBusinessInformation, this.args.riskProfileUnits);
  }
  openVeriff() {
    this.verificationBanners.openVeriff(this.args.riskProfileUnits);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "verificationBanners", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "openPendingSSP", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openPendingSSP"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openRecasedSSP", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openRecasedSSP"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openVeriff", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openVeriff"), _class.prototype), _class);
export { VerificationBanner as default };